module.exports = __webpack_public_path__ + "img/work-worries.52569268.svg";